import React, { FC } from 'react'

import { TransitionLinkTextDecoration, Txt } from 'src/components/atoms'

type Props = {
  text: string
  className?: string
}

export const TransitionLinkTxt: FC<Props> = ({ text, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-gap-s-2 tw-cursor-pointer">
        <Txt className="tw-text-roovPrimary-default tw-font-bold tw-underline">{text}</Txt>
        <TransitionLinkTextDecoration className="tw-w-s4" />
      </div>
    </div>
  )
}
